import { c as _c } from "react/compiler-runtime";
import SplashScreen from '@/components/screens/SplashScreen';
interface Props {
  isBrowser: boolean;
}
export default function LoadingScreen(t0) {
  const $ = _c(3);
  const {
    isBrowser
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-center text-3xl italic animate-pulse">Freedom is never given quickly.<br /><br />Loading...</h3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isBrowser) {
    t2 = <SplashScreen isBrowser={isBrowser}>{t1}</SplashScreen>;
    $[1] = isBrowser;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}